/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/255/interface/api/cat_5922
 */
import { message } from 'ant-design-vue'
import {
  admin_mixCol_checkMixCol_post,
  admin_mixCol_getMixColDetail_mixId_get,
  admin_mixCol_page_post,
  admin_mixCol_remove_mixId_get,
  admin_mixCol_saveMixCol_post,
  mixCol_checkMixCol_post,
  mixCol_getMixColDetail_mixId_get,
  mixCol_page_post,
  mixCol_remove_mixId_get,
  mixCol_saveMixCol_post
} from 'server/modules/5922' // 校验混合collection

export const admin_mixCol_checkMixCol_post_ = async function(params) {
  const { success, data, retInfo } = await admin_mixCol_checkMixCol_post(params)

  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
} // 查询混合collection详情

export const admin_mixCol_getMixColDetail_mixId_get_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await admin_mixCol_getMixColDetail_mixId_get(params)

  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
} // 分页查询混合collection信息

export const admin_mixCol_page_post_ = async function(params) {
  const { success, data, retInfo } = await admin_mixCol_page_post(params)

  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
} // 解除

export const admin_mixCol_remove_mixId_get_ = async function(params) {
  const { success, data, retInfo } = await admin_mixCol_remove_mixId_get(params)

  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
} // 保存混合collection

export const admin_mixCol_saveMixCol_post_ = params =>
  new Promise(reslove => {
    admin_mixCol_saveMixCol_post(params).then(res => {
      reslove(res)
    })
  })

// 校验混合collection

export const mixCol_checkMixCol_post_ = (params = {}) =>
  new Promise(resolve => {
    mixCol_checkMixCol_post(params).then(res => {
      resolve(res)
    })
  }) // 解除

export const mixCol_getMixColDetail_mixId_get_ = (params = {}) =>
  new Promise(resolve => {
    mixCol_getMixColDetail_mixId_get(params).then(res => {
      resolve(res)
    })
  }) // 解除

export const mixCol_page_post_ = params =>
  new Promise(resolve => {
    mixCol_page_post(params).then(res => {
      resolve(res)
    })
  }) // 解除

export const mixCol_remove_mixId_get_ = (params = {}) =>
  new Promise(reslove => {
    mixCol_remove_mixId_get(params).then(res => {
      reslove(res)
    })
  })

export const mixCol_saveMixCol_post_ = (params = {}) =>
  new Promise(reslove => {
    mixCol_saveMixCol_post(params).then(res => {
      reslove(res)
    })
  })
